module.exports = __webpack_public_path__ + "img/ic_64_feature_battle.c0d84a5f.svg";